import { render, staticRenderFns } from "./addSite.vue?vue&type=template&id=79b82018&scoped=true"
import script from "./addSite.vue?vue&type=script&lang=js"
export * from "./addSite.vue?vue&type=script&lang=js"
import style0 from "./addSite.vue?vue&type=style&index=0&id=79b82018&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b82018",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b82018')) {
      api.createRecord('79b82018', component.options)
    } else {
      api.reload('79b82018', component.options)
    }
    module.hot.accept("./addSite.vue?vue&type=template&id=79b82018&scoped=true", function () {
      api.rerender('79b82018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/page/addSite.vue"
export default component.exports